// extracted by mini-css-extract-plugin
module.exports = {"image":"request-feature_image__IUuCJ"};